import { createContext } from 'react';
import User from '@/models/User';

interface AuthContextValue {
  currentUser: User | null;
  isCurrentUserAdmin: () => boolean;
  isCurrentUserDebugger: () => boolean;
  login: (email: string, password: string, rememberMe?: boolean) => Promise<void>;
  /** Replaces the current session with a session of the given user. Admins only. */
  loginAs: (email: string) => Promise<void>;
  signin: (
    email: string,
    password: string,
    firstName: string,
    lastName: string,
    phone: string,
    privacyConsent: { accepted: boolean; version: string; acceptedAt: string },
  ) => Promise<void>;
  forgotPassword: (email: string) => Promise<void>;
  renewForgotPassword: (email: string, newPassword: string, verificationToken: string) => Promise<void>;
  logout: () => void;
  /**
   * Patches the details of the session already in hand - the name and phone the user just edited
   * on the settings screen (HAT-1127). Not a change of identity, so unlike a login it leaves the
   * query cache alone; it exists so the name in the header stops showing the old one.
   */
  updateCurrentUserDetails: (details: Partial<Pick<User, 'firstName' | 'lastName' | 'phoneNumber'>>) => void;
  isUserTokenExpired: () => boolean;
}

const AuthContext = createContext<AuthContextValue | undefined>(undefined);
export default AuthContext;
